import { Box, GridItem, Heading, Text, Flex } from "@chakra-ui/react";
import { FC, useState } from "react";
import { Avatar } from "components/avatar";
import { TeamUserListingItemGrid } from "./teamUserListingItemGrid";
import { baseRESTUrl } from "lib/utils";
import { useTeamUserActionContext } from "./teamUserActionProvider";
import { TeamUserListingItemMenu } from "./teamUserListingItemMenu";
import { TeamUser } from "lib/types";

export const TeamUserListingItem: FC<{ member: TeamUser }> = ({ member }) => {
  const [highlighted, setHighlighted] = useState<boolean>(false);
  const { openDelete } = useTeamUserActionContext();

  const onClose = () => setHighlighted(false);

  const handleDeleteOpen = () => {
    openDelete(member, onClose);
    setHighlighted(true);
  }

  return (
    <Box
      w={"100%"}
      layerStyle={["with-box-shadow-light", highlighted && "with-selected"]}
      borderRadius={"md"}
      pr={[3, 4]}
      pl={[3, 4]}
      pt={3}
      pb={3}
      bgColor={"bg.50"}
    >
      <TeamUserListingItemGrid>
        <GridItem colSpan={1}>
          <Avatar
            data={{
              name: `${member.user.first_name} ${member.user.last_name}`,
              src: member.user.has_avatar ? `${baseRESTUrl()}/v1/users/${member.user.id}/avatar` : null,
            }}
            size="sm"
          />
        </GridItem>
        <GridItem rowSpan={1}>
          <Flex flexDirection="column" alignItems={['center', 'center', 'flex-start']}>
            <Heading fontSize={["sm", "md"]}>{member.user.first_name} {member.user.last_name}</Heading>
            <Text color={"text.200"} size={"sm"}>{member.user.email}</Text>
          </Flex>
        </GridItem>
        <GridItem>
          <TeamUserListingItemMenu member={member} onDelete={handleDeleteOpen} />
        </GridItem>
      </TeamUserListingItemGrid>
    </Box>
  )
}
